import React from 'react';
import { Typography, useMediaQuery, useTheme } from '@material-ui/core';

import carVariantImage from '@images/variantsGroup.png';

export const VariantImage = ({ shortcode }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <div
      style={{
        overflow: 'hidden',
        margin: 'auto',
        background: '#5F6364',
        height: '187.64px',
      }}
    >
      <Typography
        variant="subtitle1"
        style={{
          marginLeft: isMobile ? '6%' : '2%',
          marginTop: isMobile ? '6%' : '2%',
          position: 'absolute',
          color: 'white',
        }}
      >
        Lucid Models
      </Typography>
      <img
        style={{
          objectFit: 'contain',
          resizeMode: 'contain',
          width: '100%',
          height: '100%',
          padding: isMobile ? '20% 5% 5% 5%' : '5% 5% 5% 5%',
        }}
        src={carVariantImage}
        alt={shortcode}
      />
    </div>
  );
};
